import { render, staticRenderFns } from "./UserCategorySelect.vue?vue&type=template&id=cad43fb2"
import script from "./UserCategorySelect.vue?vue&type=script&lang=js"
export * from "./UserCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports